function last(array)
{
	if (!array)	return null;
	var length = array.length;
	return length ? array[length - 1] : undefined;
}

export default last;
